<div class="datePicker1" style="float: right; display: flex">
  <input
    id="dateRangePicker"
    aria-label="Date range"
    class="form-control"
    #dp="bsDaterangepicker"
    bsDaterangepicker
    data-date-container="#myModalId"
    [(ngModel)]="bsRangeValue"
    [placement]="datePickerPlacement"
    [bsConfig]="{ containerClass: 'theme-dark-blue', adaptivePosition: true }"
    (bsValueChange)="onValueChange($event)"
  />
  <i
    (click)="dp.toggle()"
    (keydown)="dp.toggle()"
    style="margin-left: -20px; margin-top: 8px; color: white"
    [attr.aria-expanded]="dp.isOpen"
    class="fa fa-chevron-down"
    aria-hidden="true"
  ></i>
</div>
